import React, { useEffect } from 'react';

import { getTags } from '../../../api/tags';

import DataTable from '../../../components/DataTable';
import { classNames } from '../../../components/helpers/functions';
import { TAG_COLOR_OPTIONS } from '../../../components/helpers/constants';

import useModal from '../../../hooks/useModal';
import usePrevious from '../../../hooks/usePrevious';
import useAsync from '../../../hooks/useAsync';

const Tags = ({ module, onRefresh }) => {
	const { open: quickAddTag, setOpen: onOpenQuickTagAdd } =
		useModal('addTagModal');
	const { value: tags, execute: onRefreshTags } = useAsync(getTags);

	const prevAddTag = usePrevious(quickAddTag);
	useEffect(() => {
		if (!quickAddTag && prevAddTag) {
			onRefreshTags(null, null, { silent: true });
		}
	}, [quickAddTag]);
	return (
		<DataTable
			columns={[
				{
					header: 'NAME',
					accessorKey: 'name',
					cell: (info) => info?.getValue() || null,
				},
				{
					header: 'COLOR',
					accessorKey: 'color',
					cell: (info) => {
						const color = TAG_COLOR_OPTIONS?.find(
							(o) => o.key === info?.getValue()
						);

						return (
							<div
								className={classNames(
									`w-4 h-4 rounded ${color?.preview} ring-offset-2 cursor-pointer`,
									'ring-0'
								)}
							/>
						);
					},
				},
			]}
			data={{ rows: tags?.sort((a, b) => a.name?.localeCompare(b.name)) || [] }}
			onRow={(row) =>
				onOpenQuickTagAdd({
					id: row?.original?.id,
					label: row?.original?.name,
					color: row?.original?.color,
				})
			}
			hasCheckboxes={false}
			usePagination={false}
			useSearch={false}
			useExport={false}
			actions={[{ label: 'Add Tag', onClick: () => onOpenQuickTagAdd() }]}
		/>
	);
};

export default Tags;
